import $ from "jquery";
function navbarSelector(){ return $('header#navbar'); }

export function hideNavbar(){
  navbarSelector().addClass('hide-navbar');
}

export function showNavbar(){
  navbarSelector().removeClass('hide-navbar');
}

export function removeBodyScroll(){
  document.body.style.overflow = 'hidden';
}

export function restoreBodyScroll(){
  document.body.style.removeProperty("overflow");
}